module.exports = __webpack_public_path__ + "img/LINE_SOCIAL_Basic.414687b5.png";